export default __webpack_public_path__ + "static/media/icon-product-nooio-smartclick.73df2c1f.svg";